import Constants from '../../common/constants';

import story1 from './stories/story1';
import story2 from './stories/story2';
import story3 from './stories/story3';
import story4 from './stories/story4';
import story5 from './stories/story5';
import story6 from './stories/story6';
import story7 from './stories/story7';
const imageFolder = Constants.IMAGE_FOLDER;
const storyUrl = `/nl${Constants.STORY_URL}`;

export default [
    {
        type: "story",
        time: 668,
        title: "De Puber",
        link: {
            url: `${storyUrl}depuber`,
            label: "Bekijk verhaal",
        },
        location: {
            name: "Gush Etzion"
        },
        readingTime: "Leestijd: 6 min",
        excerpt: "Emuna is veertien. Ze had een dansvoorstelling, samen met haar vriendin Hallel. Vlak voor het optreden werd Hallel doodgestoken. In haar eigen slaapkamer.",
        body: story1,
        image: {
            mobile: `${imageFolder}depuber/omslag__mobile.jpg`,
            tablet: `${imageFolder}depuber/omslag.jpg`,
            desktop: `${imageFolder}depuber/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 797,
        title: "De Kiloknaller",
        link: {
            url: `${storyUrl}dekiloknaller`,
            label: "Bekijk video",
        },
        location: {
            name: "Gush Etzion"
        },
        readingTime: "Kijktijd: 6 min ",
        excerpt: "Zowel kolonisten als Palestijnen kopen hun kip bij Rami Levy, de goedkoopste supermarkt in de omgeving. Maar de prijsvechter staat wel in een nederzetting. De Joden hier dragen wapens, de Palestijnen niet.",
        body: story2,
        image: {
            mobile: `${imageFolder}dekiloknaller/omslag__mobile.jpg`,
            tablet: `${imageFolder}dekiloknaller/omslag.jpg`,
            desktop: `${imageFolder}dekiloknaller/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 1039,
        title: "De Heilige",
        link: {
            url: `${storyUrl}deheilige`,
            label: "Bekijk verhaal",
        },
        location: {
            name: "Bethlehem"
        },
        readingTime: "Leestijd: 7 min",
        excerpt: "Het graf van de oermoeder Rachel ligt in Bethlehem, maar je kunt er alleen vanuit Israël naartoe. Is dit bijbels hartland, of de essentie van koloniale logica?",
        body: story3,
        image: {
            mobile: `${imageFolder}deheilige/omslag__mobile.jpg`,
            tablet: `${imageFolder}deheilige/omslag.jpg`,
            desktop: `${imageFolder}deheilige/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 1243,
        title: "De Standvastige",
        link: {
            url: `${storyUrl}destandvastige`,
            label: "Bekijk video",
        },
        location: {
            name: "Jeruzalem"
        },
        readingTime: "Kijktijd 5 min",
        excerpt: "De Palestijnse familie Sub Laban woont in de moslimwijk van de Oude Stad in Jeruzalem. Ooit woonden hier Joden. Daarom wordt hun huis onteigend.",
        body: story4,
        image: {
            mobile: `${imageFolder}destandvastige/omslag__mobile.jpg`,
            tablet: `${imageFolder}destandvastige/omslag.jpg`,
            desktop: `${imageFolder}destandvastige/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 1511,
        title: "De Demonstrant",
        link: {
            url: `${storyUrl}dedemonstrant`,
            label: "Bekijk video",
        },
        location: {
            name: "Ramallah"
        },
        readingTime: "Kijktijd: 8 min ",
        excerpt: "Zijn strijd naam is Tito. Hij trekt er elke week op uit om tegen het Israëlische leger te demonstreren. Het is David tegen Goliath, zegt hij. Maar hij kan niet anders.",
        body: story5,
        image: {
            mobile: `${imageFolder}dedemonstrant/omslag__mobile.jpg`,
            tablet: `${imageFolder}dedemonstrant/omslag.jpg`,
            desktop: `${imageFolder}dedemonstrant/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 1733,
        title: "De Pionier",
        link: {
            url: `${storyUrl}depionier`,
            label: "Bekijk video",
        },
        location: {
            name: "Amona"
        },
        readingTime: "Kijktijd: 10 min",
        excerpt: "De Joodse buitenpost Amona was gebouwd op het land van Palestijnse boeren. De Palestijnen stapten naar de rechter, en wonnen. Met dank aan een Joodse Israëliër.",
        body: story6,
        image: {
            mobile: `${imageFolder}depionier/omslag__mobile.jpg`,
            tablet: `${imageFolder}depionier/omslag.jpg`,
            desktop: `${imageFolder}depionier/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 2013,
        title: "De Vrienden",
        link: {
            url: `${storyUrl}devrienden`,
            label: "Bekijk verhaal",
        },
        location: {
            name: "Jenin"
        },
        readingTime: "Leestijd: 7 min",
        excerpt: "Deze jongens waren rond de tien toen het Israëlische leger in 2002 hun vluchtelingenkamp deels verwoestte. Ze zijn nog steeds vrienden.",
        body: story7,
        image: {
            mobile: `${imageFolder}devrienden/omslag__mobile.jpg`,
            tablet: `${imageFolder}devrienden/omslag.jpg`,
            desktop: `${imageFolder}devrienden/omslag.jpg`,
            alt: ""
        }
    }
]



// WEBPACK FOOTER //
// ./src/data/nl/timeline-stories.js